/*
 * 文件相关的全局交互
 */

(function($) {

$(function() {

    tower.stack.on('pageunload', function(e, $page) {
        var $uploadings = $('.file-list .file.uploading')
        if( $uploadings.length > 0  && !window.confirm("有文件正在上传,现在离开正在上传的文件可能丢失,确定要离开吗?")){
            return false;
        }
        else{
            $uploadings.each(function(i,e){
                $("a.link-cancel",e).trigger('click');
            });
            $(document).off('click.files-view');
            $(window).off('scroll.files-view');
        }
    });


    // switch files view
    $(document).on('click', '.files-view .switch-view .link-view', function(e) {
        var $link = $(this);
        if ($link.hasClass('active')) {
            return;
        }

        $link.addClass('active')
            .siblings('.link-view')
            .removeClass('active');

        var cacheKey = simple.url().toString('relative') + 'files-view';
        if ($link.hasClass('link-grid-view')) {
            $link.closest('.files-view')
                .addClass('grid-view')
                .removeClass('list-view');
            simple.util.storage.set(cacheKey, 'grid');
        } else {
            $link.closest('.files-view')
                .addClass('list-view')
                .removeClass('grid-view');
            simple.util.storage.set(cacheKey, 'list');
        }
    });


    // sort file list
    $(document).on('click', '.files-view.list-view .file-header[data-sortable]', function(e) {
        var $header = $(this);
        var desc = $header.data('sortable') == 'desc' ? 'asc' : 'desc';
        var col;

        if ($header.hasClass('name-header')) {
            col = 'name';
        } else if ($header.hasClass('size-header')) {
            col = 'size';
        } else if ($header.hasClass('update-time-header')) {
            col = 'update-time';
        }

        tower.sortFileList(col, desc);

        var cacheKey = simple.url().toString('relative') + 'file-list-sort';
        simple.util.storage.set(cacheKey, col + ';' + desc);
    });


    // select files in file list
    $(document).on('click', '.files-view.list-view .dir, .files-view.list-view .file:not(.design)', function(e) {
        var $target = $(e.target);
        if ($target.is('a') || $target.closest('a').length > 0 || $target.closest('.file-or-dir').is('.dir-default')) {
            return;
        }

        e.preventDefault();
        var $item = $(this);
        var $view = $item.closest('.files-view');
        var baseSelected = $view.data('base-selected');
        if (!baseSelected) return;
        if ($item.find('.link-move').length === 0) return;

        if (e.shiftKey) {
            var lastSelected = baseSelected[baseSelected.length - 1];
            if (baseSelected.length < 1) {
                $item.addClass('selected');
                baseSelected.push($item[0]);
            } else if (lastSelected === $item[0]) {
                $item.parent('.file-list').children().removeClass('selected');
                $(baseSelected).addClass('selected');
            } else {
                var $items = $item.parent('.file-list').children().removeClass('selected');
                if ($items.index($item) > $items.index(lastSelected)) {
                    $item.prevUntil(lastSelected)
                        .addBack()
                        .addClass('selected');
                } else {
                    $item.nextUntil(lastSelected)
                        .addBack()
                        .addClass('selected');
                }

                $(baseSelected).addClass('selected');
            }
        } else if (tower.metaKey(e)) {
            if ($item.hasClass('selected')) {
                $item.removeClass('selected');

                var index = $.inArray($item[0], baseSelected);
                if (index > -1) {
                    baseSelected.splice(index, 1);
                }
            } else {
                $item.addClass('selected');
                baseSelected.push($item[0]);
            }
        } else {
            $item.addClass('selected')
                .siblings('.file-or-dir')
                .removeClass('selected');
            baseSelected.length = 0;
            baseSelected.push($item[0]);
        }

        tower.refreshSelectedFiles();

    }).on('click', '.files-view .selected-info .link-cancel-select', function(e) {
        e.preventDefault();
        var $view = $('.files-view');
        var baseSelected = $view.data('base-selected');
        if (!baseSelected) return;
        $view.find('.file-or-dir').removeClass('selected');
        tower.refreshSelectedFiles();

        baseSelected.length = 0;
    });


    // shortcut links for deleting file and dir
    $(document).on( "ajax:success", ".file .link-delete", function( e ) {
        var fileEl = $( this ).closest( ".file" );
        fileEl.fadeOut( function() {
            fileEl.remove();
             tower.refreshSelectedFiles();
        });
    }).on( "ajax:success", ".attachment .link-delete", function( e ) {
        var fileEl = $( this ).closest( ".attachment" );
        fileEl.fadeOut( function() {
            fileEl.remove();
        });
    }).on( "ajax:success", ".dir .link-delete", function( e ) {
        var dirEl = $( this ).closest( ".dir" );
        dirEl.fadeOut( function() {
            dirEl.remove();
            tower.refreshSelectedFiles();
        });
    });

    // create dir
    $(document).on('click', '.btn-create-dir', function(e) {
        e.preventDefault();
        var $btn = $(this);
        $btn.closest('.btn-group').removeClass('dropdown');

        var $listEl = $('.file-list');
        var $dirEl = $listEl.find('.dir.new');

        if ($dirEl.length < 1) {
            $dirEl = $($('#tpl-create-dir').html()).prependTo($listEl);
            $dirEl.attr({
                'data-url': '/projects/' + $btn.data('guid') + '/dirs/',
                'data-parent-guid': $btn.data('dir-guid')
            });
        }

        $('.init-file').hide();
        $('.files-view').show();
        $dirEl.find('.txt-dir-name').focus().select();
    }).on('click', '.js-rename-dir', function(e) {
        $('.crumb .current-dir').trigger('click');
    }).on('click', '.dir.new .link-submit-dir', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $dirEl = $link.closest('.dir.new');
        var $fileList = $dirEl.closest('.file-list');

        if ($dirEl.hasClass('loading')) {
            return;
        }

        var $txtName = $dirEl.find('.txt-dir-name');
        var name = $txtName.val();

        if (!name) {
            $txtName.addClass('error');
            return;
        } else {
            $txtName.removeClass('error');
        }

        $dirEl.addClass('loading');
        $txtName.prop('disabled', true);
        $.ajax({
            url: $dirEl.data('url'),
            data: {
                name: name,
                parent_dir_guid: $dirEl.data('parent-guid')
            },
            success: function(result) {
                var $newDirEl = $(result.html);
                $dirEl.replaceWith($newDirEl);

                if ($('#page-project').length) {
                    $newDirEl.find('a[data-stack-replace]').removeAttr('data-stack-replace');
                    $fileList.find( ".file-or-dir:gt(9)" ).remove();
                }

                tower.adjustReadableTime($newDirEl);
                tower.initPermission($newDirEl);

                $fileList.trigger('dircreate', [$newDirEl]);
            }
        });
    }).on('click', '.dir.new .link-cancel-dir', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $dirEl = $link.closest('.dir.new');
        if ($dirEl.hasClass('loading')) {
            return;
        }

        $link.closest('.dir.new').fadeOut(function() {
            $(this).remove();
        });
    }).on('keydown', '.dir.new .txt-dir-name', function(e) {
        if (e.which == 27) {
            e.preventDefault();
            $(this).closest('.dir').find('.link-cancel-dir').trigger('click');
        } else if (e.which == 13) {
            e.preventDefault();
            $(this).closest('.dir').find('.link-submit-dir').trigger('click');
        }
    });

    // change dir
    $(document).on('click', '.control-dir .link-change-dir', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $btn = $link.parent();
        if ($btn.hasClass('disabled')) {
            return;
        }

        var popover = $link.data('popover');
        var $popover = $(simple.tpl( $('#tpl-dir-popover').html()));
        var $dirs = $popover.find('.dirs');
        var $input = $dirs.find('#txt-dir-name');
        var $form = $dirs.find('.form');
        var url = $dirs.data('url');
        var moveUrl = $link.data('url') || $link.attr('href');
        var pageId = $('.page:last .page-inner').attr('id');
        var fileOrDirGuid = $link.data('guid');

        if (popover) {
            popover.destroy();
        } else {
            $btn.addClass('active');

            if ($btn.hasClass('no-dir')) {
                $popover.find('.remove-dir').hide();
            }

            var tree = simple.tree({
                el: $dirs,
                url: url + '?show_root_dir=true',
                loading: true,
                placeholder: '没有创建过文件夹',
                nodeProperties: {
                    id: 'guid',
                    params: {
                        parent_dir_guid: 'guid'
                    }
                },
                onNodeRender: function($node, item) {
                    if ($.inArray(item.guid, fileOrDirGuid) > -1) {
                        $node.remove();
                    } else {
                        $node.find('.toggle').after('<i class="icon-folder twr twr-folder"/>');
                    }
                }
            });

            popover = simple.popover({
                pointTo: $link,
                content: $popover,
                offset: {
                    y: 0,
                    x: -5
                }
            });

            popover.on('popover:destroy', function(e) {
                $btn.removeClass('active');
            });

            $dirs.on('mousewheel', function(e, delta) {
                $(this).scrollTop($(this).scrollTop() - 26 * delta);
                return false;
            });

            $input.on('focus', function() {
                $form.addClass('active');
            }).on('keyup', function() {
                if ($input.val().length) {
                    $form.find('.link-submit-dir').removeClass('disabled');
                } else {
                    $form.find('.link-submit-dir').addClass('disabled');
                }
            });

            $form.on('ajax:success', function(e, result) {
                tree.trigger('nodeselected', [null, { guid: result.guid }]);
            }).find('.link-submit-dir').on('click', function(e) {
                e.preventDefault();
                if (!$(this).hasClass('disabled')) {
                    $form.trigger('submit');
                }
            });

            tree.on('nodeselected', function(e, $node, item) {
                if (item.guid === fileOrDirGuid) {
                    popover.destroy();
                    return false;
                }

                $.ajax({
                    url: moveUrl,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        target_dir_guid: item.guid
                    },
                    success: function(result) {
                        if (result.guid) {
                            $btn.removeClass('no-dir')
                                .find('.link-to-dir')
                                .text(result.name)
                                .attr('href', result.url);
                            $link.html('<i class="twr twr-more"></i>');
                        } else {
                            $btn.addClass('no-dir')
                                .find('.link-to-dir')
                                .text('')
                                .attr('href', '');
                            $link.text('文件夹');
                        }

                        $link.data('guid', result.guid || '');
                        popover.destroy();
                    }
                });
            });

            $popover.find('.link-remove-dir').on('click', function(e) {
                e.preventDefault();
                $.ajax({
                    url: moveUrl,
                    type: 'post',
                    dataType: 'json',
                    data: {
                        target_dir_guid: ''
                    },
                    success: function(result) {
                        $btn.addClass('no-dir')
                            .find('.link-to-dir')
                            .text('');
                        $link.text('文件夹');

                        $link.data('guid', '');
                        popover.destroy();
                    }
                });
            });
        }
    }).on('click', '.detail-action-change .detail-action, .file-or-dir .link-move, .selected-info .link-move-file', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var $link = $(this);
        var $dialog = $(simple.tpl($('#tpl-dir-dialog').html()));
        var $dirs = $dialog.find('.dirs');
        var $submit = $dialog.find('button[type=submit]');
        var dirGuids = [$link.data('dir-guid')];
        var projectGuid = $link.data('project-guid');

        var items = $link.data('items');
        if (items) {
            dirGuids = items.dirs;
        }

        var tree = renderTree($dialog, projectGuid, dirGuids);
        var select = initSelectProj($dialog, tree);

        tree.on('nodeselected', function(e, $node, item) {
            $dialog.find('.target-dir-guid').val(item.guid);
            $dialog.find('.tpuid').val();
            $submit.prop('disabled', false);
        });

        var dialog = simple.dialog({
            content: $dialog,
            width: 450,
            modal: true,
            buttons: null
        });

        $dialog.find('.form-change').attr('action', $link.data('move-url'));
        $dialog.find('.form-change .name').text($link.data('name'));


        $dialog.find('.btn-cancel-move').on('click', function(e) {
            dialog.remove();
        });

        if (items) {
            $dialog.find('.form-change').on('ajax:beforeSend', function(e, xhr, settings) {
                var uploads = $.map(items.uploads, function(guid, i) {
                    return {
                        upload: guid
                    };
                });
                var attachments = $.map(items.attachments, function(guid, i) {
                    return {
                        attachment: guid
                    };
                });
                var dirs = $.map(items.dirs, function(guid, i) {
                    return {
                        attachmentdir: guid
                    };
                });
                var resources = $.merge(uploads, $.merge(attachments, dirs));
                settings.data += "&resources=" + JSON.stringify(resources);
            });
        }

        $dialog.find('.form-change').on('ajax:success', function(e, result) {
            if (result.task_guid) {
                simple.loading({
                    type: 'tiny',
                    msg: '正在移动中...'
                });

                var channel = tower.tempPusher(process.env.PUSHER_CHANNEL_PREFIX + tower.me.id);
                channel.bind('pusher:subscription_succeeded', function(){
                    $.ajax({
                        url: '/attachmentdirs/movement_tasks/' + result.task_guid,
                        method: 'GET',
                        dataType: 'json',
                        success: function(data) {
                            if ( data.status == 'processed' || data.status == 'failed' ) {
                                if (!!tower.tempPusherSocket) {
                                    tower.tempPusherSocket.disconnect();
                                }
                                tower.tempPusherSocket = null;

                                simple.loading.destroy();
                            }

                            if (data.status == 'processed') {
                                simple.dialog.message({content: '移动成功'});
                            } else if (data.status == 'failed') {
                                simple.dialog.message({content: '移动失败，请刷新重试'});
                            }
                        }
                    })
                });
                channel.bind('attachmentdirs_movement', function(data) {
                    if (!!tower.tempPusherSocket) {
                        tower.tempPusherSocket.disconnect();
                    }
                    tower.tempPusherSocket = null;

                    simple.loading.destroy();

                    if (data.success) {
                        simple.dialog.message({content: '移动成功'});
                    } else {
                        simple.dialog.message({content: '移动失败，请刷新重试'});
                    }
                });
            }

            var targetDirGuid = $dialog.find('.target-dir-guid').val();
            var needRemove = !($('#page-folder').length > 0 && $('#page-folder').data('dir-guid') === targetDirGuid);
            if ($link.parent().is('.selected-info')) {
                var $view = $link.closest('.files-view');
                if (needRemove) {
                    $view.find('.file-list .file-or-dir.selected').remove();
                } else {
                    $view.find('.file-list .file-or-dir.selected').removeClass('selected');
                }

                tower.refreshSelectedFiles();

                var baseSelected = $view.data('base-selected');
                baseSelected.length = 0;
            } else if (needRemove) {
                $link.closest('.file-or-dir').fadeOut(function() {
                    $(this).remove();
                });
            }

            dialog.remove();
        });

        $dirs.on('mousewheel', function(e, delta) {
            $(this).scrollTop($(this).scrollTop() - 30 * delta);
            return false;
        });
    }).on('click', '.control-dir .link-tag-attachment', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $btn = $link.parent();
        if ($btn.hasClass('disabled')) {
            return;
        }

        var popover = $link.data('popover');
        var $popover = $(simple.tpl( $('#tpl-attachment-popover').html()));
        var $input = $popover.find('#txt-tag-name');
        var $form = $popover.find('.form');
        var $nameDiv = $btn.parent().find('.tags');
        var url = $link.data('url');
        $form.prop('action', url);

        if (popover) {
            popover.destroy();
        } else {
            $btn.addClass('active');

            popover = simple.popover({
                pointTo: $link,
                content: $popover,
                offset: {
                    y: 0,
                    x: -5
                }
            });

            popover.on('popover:destroy', function(e) {
                $btn.removeClass('active');
            });

            $input.focus().select();
            $form.addClass('active');

            $input.on('focus', function() {
                $form.addClass('active');
            }).on('keyup', function() {
                if ($input.val().length) {
                    $form.find('.link-submit-tag').removeClass('disabled');
                } else {
                    $form.find('.link-submit-tag').addClass('disabled');
                }
            });

            $form.on('ajax:success', function(e, result) {
                if (result.success) {
                    $newName = $(result.html);
                    popover.destroy();
                    $popover.remove();
                    $nameDiv.prepend($newName);
                    tower.highlight($newName);
                }
            }).find('.link-submit-tag').on('click', function(e) {
                e.preventDefault();
                if (!$(this).hasClass('disabled')) {
                    $form.trigger('submit');
                }
            });
        }

    }).on('click', '#page-attachments-center .attachment-tag', function(e) {
        e.preventDefault();
        var url = simple.url();

        var params = {};
        params['keyword'] = $(this).data('name');
        var formParams = $('.form-condition-search').serializeObject();
        params = $.extend({}, formParams, params);

        url.search = params;
        tower.stack.load(url.toString('relative'), {
            root: true,
            // replace: true
        });

        return false;
    }).on('click', '.tag-actions .edit-tag', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $btn = $link.parent();

        if ($btn.hasClass('disabled')) {
            return;
        }

        var popover = $link.data('popover');
        var $popover = $(simple.tpl( $('#tpl-attachment-popover').html()));
        var $tag = $popover.find('#txt-tag-name');
        var $originTag = $popover.find('#origin-tag');
        var $form = $popover.find('.form');
        var url = $link.data('url');
        var originName = $link.data('name');
        var $tagActions = $btn.parent();
        var $tagDiv = $tagActions.parent();
        var $tagName = $tagDiv.find('.tag-content');
        $form.prop('action', url);
        $tag.prop('value', originName);
        $originTag.prop('value', originName);


        if (popover) {
            popover.destroy();
        } else {
            $btn.addClass('active');

            popover = simple.popover({
                pointTo: $tagName,
                content: $popover,
                offset: {
                    y: 0,
                    x: -5
                }
            });

            $tagActions.hide();
            $tag.focus().select();
            $form.addClass('active');
            $form.find('.link-submit-tag').removeClass('disabled');

            popover.on('popover:destroy', function(e) {
                $btn.removeClass('active');
                $tagActions.css('display', '');
            });

            $tag.on('focus', function() {
                $form.addClass('active');
            });

            $form.on('ajax:success', function(e, result) {
                if (result.success) {
                    $newName = $(result.html);
                    popover.destroy();
                    $popover.remove();
                    $tagDiv.replaceWith($newName);
                    tower.highlight($newName);
                }
            }).find('.link-submit-tag').on('click', function(e) {
                e.preventDefault();
                if (!$(this).hasClass('disabled')) {
                    $form.trigger('submit');
                }
            });
        }
    }).on('ajax:success', '.tag-actions .del-tag', function(e, result) {
        if (result.success)
            var $link = $(this);
            var $btn = $link.parent();
            var $tagActions = $btn.parent();
            var $tagDiv = $tagActions.parent();
            $tagDiv.remove();
    });

    // 文件视图删除附件（实际为移出文件夹）
    $(document).on('click', '.file .link-delete-attachment', function(e) {
        var $link = $(this);
        var $file = $link.closest('.file');
        var dialog = simple.dialog.confirm({
            content: '确定要删除这个文件吗？',
            callback: function(e, yes) {
                dialog.remove();
                if (yes) {
                     $.ajax({
                        url: $link.data('url'),
                        type: 'post',
                        dataType: 'json',
                        success: function(result) {
                            $file.fadeOut( function() {
                                $file.remove();
                                tower.refreshSelectedFiles();
                            });
                        }
                    });
                }
            }
        });
    });

    function initSelectProj($dialog, tree) {
        var $select = $dialog.find('.choose-projects');

        var select = simple.select({
            el: $select,
            placeholder: '点击选择项目',
            cls: 'select-choose-projects'
        });

        $.ajax({
            url: "/members/" + tower.me.guid + "/projects.json/",
            type: 'get',
            dataType: 'json',
            success: function(result) {
                var projGuid = $select.data('project');
                var items = [];
                var selectedItem = null;
                $.each(result, function(i, proj) {
                    var item;
                    item = {
                        label: proj.name,
                        guid: proj.guid,
                        key: proj.name + " " + proj.name_pinyin + " " + proj.name_pinyin_abbr
                    };
                    if (projGuid === item.guid) {
                        selectedItem = item;
                    }
                    items.push(item);
                });
                $select.removeClass('loading');
                select.setItems(items);
                select.selectItem($.inArray(selectedItem, items));

                select.on('select', function(e, item) {
                    var showRoot = '';
                    if (projGuid !== item.guid || $('#page-project, #page-attachments').length < 1) {
                        showRoot = '?show_root_dir=true';
                    }

                    $dialog.find('button[type=submit]').prop('disabled', true);
                    $dialog.find('.tpuid').val(item.guid);
                    tree.refresh({
                        url: '/projects/' + item.guid + '/folders' + showRoot
                    });
                });
            }
        });
        return select;
    }

    function renderTree($dialog, projectGuid, dirGuids) {
        var showRoot = $('#page-project, #page-attachments').length < 1 ? '?show_root_dir=true' : '';
        var tree = simple.tree({
            el: $dialog.find('.dirs'),
            url: '/projects/' + projectGuid + '/folders' + showRoot,
            placeholder: '没有创建过文件夹',
            nodeProperties: {
                id: 'guid',
                params: {
                    parent_dir_guid: 'guid'
                }
            },
            onNodeRender: function($node, item) {
                if ($.inArray(item.guid, dirGuids) > -1) {
                    $node.remove();
                } else {
                    $node.find('.toggle').after('<i class="icon-folder twr twr-todo-desc"/>');
                }
            }
        });
        return tree;
    }
});

$.extend( window.tower, {
    initFileUpload: function(opts) {
        opts = opts || {};
        var uploadBtn = opts.btn ? $( opts.btn ) : $( ".btn-upload-file" );
        var fileList = opts.container ? $( opts.container ) : $( ".file-list" );
        var uploadUrl = uploadBtn.data('url');

        var uploader = simple.uploader({
            url: uploadUrl,
            params: $.extend({
                conn_guid: $( "#conn-guid" ).val(),
                authenticity_token: $('meta[name=csrf-token]').attr('content')
            }, opts.params)
        });

        tower.connectUploader(uploadBtn, uploader, {
            title: '上传文件',
            multiple: true
        });

        uploadBtn.closest('.btn-group').find('.btn-dropdown-menu')
            .on('click', '.btn-local-upload a', function(e) {
                var altBtn = $(e.currentTarget);
                if (!altBtn.data('uploader')) {
                    tower.connectUploader(altBtn, uploader, {
                        title: '上传文件',
                        multiple: true
                    });
                    altBtn.find('input[type=file]').trigger('click');
                }
            });

        uploader.on('beforeupload', function(e, file) {
            uploadBtn.closest('.btn-group').removeClass('dropdown');
            if (!tower.checkUploadFileSize(file)) {
                return false;
            }

            var fileEl = $(simple.tpl($('#tpl-upload-file').html(), {
                id: file.id,
                name: file.name
            }));

            fileList.prepend( fileEl )
                .closest('.files-view')
                .show();
            $('.init-file').hide();

            // load preview image
            uploader.readImageFile(file.obj, function(img) {
                if (!img) {
                    var path = `${process.env.OSS_ASSETS_ENDPOINT}/file_icons_v2/`;
                    var imgPath = path + file.ext + ".svg";

                    simple.util.preloadImages( imgPath, function( fileIcon ) {
                        if ( !fileIcon ) {
                            fileEl.find( ".file-thumb img" )
                                .attr( "src", path + "other.svg" );
                        } else {
                            fileEl.find( ".file-thumb img" )
                                .attr( "src", fileIcon.src );
                        }
                    });
                } else {
                    fileEl.find( ".file-thumb" ).attr({
                        'data-image-src': img.src,
                        'data-image-name': file.name,
                        'data-image-size': img.width + "," + img.height
                }).find( "img" )
                    .attr('src', img.src);
                }
            });

            if (window.File && window.FileList) {
                var size = 0;
                if ( file.size >= 1048576) {
                    size = ( file.size / 1048576 ).toFixed( 1 )  + "M";
                } else {
                    size = ( file.size / 1024 ).toFixed( 0 ) + "K";
                }
            } else {
                fileEl.addClass('ie');
            }

            fileEl.find( ".size" ).text( size )
                .end()
                .find( ".link-cancel" )
                .text( "取消上传" )
                .attr( "title", "取消上传")
                .on('click', function() {
                    var fileid = fileEl.attr('fileid');
                    if ( fileid && fileEl.hasClass('uploading')) {
                        uploader.cancel(fileid);
                    }

                    if ( opts.onCancel ) {
                        opts.onCancel( fileEl );
                    }

                    fileEl.remove();
                });


            if ( opts.beforeUpload ) {
                opts.beforeUpload();
            }

            //if ( opts.countEl ) {
                //var filesCount = $( opts.countEl ),
                //txt = filesCount.text().replace(/\d+/, function(match) {
                    //return match*1 + 1
                //});
                //filesCount.text(txt).show();
            //}
        });

        uploader.on('uploadprogress', function(e, file, loaded, total) {
            var fileEl = fileList.find('.file[fileid=' + file.id + ']'),
            percent = loaded / total;

            if ( percent > 0.99 ) {
                percent = "正在处理...";
            } else {
                percent = (percent * 100).toFixed(0) + "%";
            }
            fileEl.find( ".progress-bar span" ).width( percent );
            fileEl.find( ".percent" ).text( percent );
        });

        uploader.on('uploadsuccess', function(e, file, result) {
            var fileEl = fileList.find('.file#file-upload-' + file.id );
            var newFile = $( result.html );
            fileEl = newFile.replaceAll(fileEl);

            //$( ".init.init-file" ).hide();

            if ( opts.onSuccess ) {
                opts.onSuccess( file, result );
            }

            tower.bubbleGuideClose({step:7});
            tower.highlight(fileEl);
            tower.adjustReadableTime(fileEl);
            tower.initPermission(fileEl);

            if ($('#page-project').length > 0) {
                fileEl.find('a[data-stack-replace]').removeAttr('data-stack-replace');
            }

            fileList.trigger('filecreate', [fileEl]);
        });

        uploader.on('uploaderror', function(e, file, xhr) {
            if (xhr.statusText === 'abort') return
            var fileEl = fileList.find('.file#file-upload-' + file.id );
            fileEl.removeClass('uploading').addClass('uploaderror');
            fileEl.find('.progress').css('display', 'none');
            tower.uploaderror(xhr);
        });
    },

    adjustAttachment: function( el ) {
        var page = $( ".workspace .page:last .page-inner" );
        var els = $( el ).is( ".attachment" ) ? $( el ) : $( ".attachment", el );

        if ( page.is( "[data-archived], [data-deleted]" )) {
            els.find( ".control-dir" ).addClass( "disabled" )
        }
    },

    initFileViews: function() {
        var $view = $('.files-view');

        var viewKey = simple.url().toString('relative') + 'files-view';
        var view = simple.util.storage.get(viewKey);
        if (!view && $('#page-project').length > 0) {
            view = 'grid';
            simple.util.storage.set(viewKey, view);
        }

        if (view) {
            var $link = $view.find('.switch-view .link-' + view + '-view');

            $link.addClass('active')
                .siblings('.link-view')
                .removeClass('active');

            if (view === 'grid') {
                $link.closest('.files-view')
                    .addClass('grid-view')
                    .removeClass('list-view')
            } else {
                $link.closest('.files-view')
                    .addClass('list-view')
                    .removeClass('grid-view')
            }
        }

        var sortKey = simple.url().toString('relative') + 'file-list-sort';
        var sort = simple.util.storage.get(sortKey);
        if (sort) {
            sort = sort.split(';');
            tower.sortFileList(sort[0], sort[1]);
        }


        var $selectedInfo = $view.find('.selected-info');
        $(window).on('scroll.files-view', function(e) {
            if (!$selectedInfo.is(':visible')) {
                return;
            }

            var topEdge = $view.offset().top - 43;
            var bottomEdge = topEdge + $view.outerHeight() - 80;
            var scrollTop = $(document).scrollTop();

            if (scrollTop <= topEdge || scrollTop >= bottomEdge) {
                $selectedInfo
                    .css('left', '')
                    .removeClass('floating');
            } else {
                $selectedInfo
                    .css('left', $selectedInfo.offset().left)
                    .addClass('floating');
            }
        });

        if ($('.selected-info').length > 0) {
            $view.data('base-selected', []);
        }

        $(document).on('click.files-view', function(e) {
            var baseSelected = $view.data('base-selected');
            if (!baseSelected) {
                return;
            }

            var $target = $(e.target);
            if ($target.closest('.file-list, .selected-info, .simple-dialog-modal, .simple-dialog').length < 1) {
                $view.find('.file-or-dir').removeClass('selected');
                tower.refreshSelectedFiles();
                baseSelected.length = 0;
            }
        });

    },

    sortFileList: function(col, order) {
        var $view = $('.files-view');
        var $list = $view.find('.file-list');
        var $header = $view.find('.' + col + '-header');
        var $rows = $list.find('.file, .dir');

        if ($view.length < 1) {
            return;
        }

        if (col === 'name') {
            $rows.sort(function(row1, row2) {
                var name1 = $.trim($(row1).find('.link-name').text());
                var name2 = $.trim($(row2).find('.link-name').text());
                return name2.localeCompare(name1, undefined, {
                    numeric: true
                });
            });
        } else if (col == 'size') {
            $rows.sort(function(row1, row2) {
                var $row1 = $(row1);
                var $row2 = $(row2);
                if ($row1.hasClass('dir') && $row2.hasClass('dir')) {
                    return $(row2).find('.dir-size').data('size') * 1 - $(row1).find('.dir-size').data('size') * 1;
                } else if ($row1.hasClass('file') && $row2.hasClass('file')) {
                    return $(row2).find('.file-size').data('size') * 1 - $(row1).find('.file-size').data('size') * 1;
                } else if ($row2.hasClass('dir')) {
                    return 1;
                } else if ($row2.hasClass('file')) {
                    return -1;
                }
            });
        } else if (col == 'update-time') {
            $rows.sort(function(row1, row2) {
                var date1 = $(row1).find('.dir-update-time span, .file-update-time span').data('readable-time');
                var date2 = $(row2).find('.dir-update-time span, .file-update-time span').data('readable-time');
                var format = "YYYY-MM-DD HH:mm:ss Z";
                date1 = moment.tz(date1, format, tower.me.tz);
                date2 = moment.tz(date2, format, tower.me.tz);

                return date2.diff(date1);
            });
        }

        $header.attr('data-sortable', order)
            .removeData('sortable');

        if (order == 'asc') {
            $rows = $($rows.get().reverse());
        }

        $header.siblings('.file-header[data-sortable]')
            .attr('data-sortable', '')
            .removeData('sortable');
        $list.append($rows);
    },

    initFileDnD: function(listEl) {
        var $listEl = listEl ? $(listEl) : $('.file-list');

        if (tower.me.admin) {
            makeDraggable($listEl.find('.file, .dir:not(.dir-default)'));
            makeDroppable($listEl.find('.dir:not(.dir-default)'));
            makeDroppable($('.crumb').find('.link-dir'));
        }

        $listEl.on('filecreate', function(e, $fileEl) {
            makeDraggable($fileEl);
        });

        $listEl.on('dircreate', function(e, $dirEl) {
            makeDraggable($dirEl);
            makeDroppable($dirEl);
        });

        function makeDraggable($dragEl) {
            $dragEl.draggable({
                scope: 'move-file',
                cancel: '.files-view.list-view *',
                zIndex: 100,
                cursorAt: {
                    top: -5,
                    left: -5
                },
                helper: function() {
                    var $el = $(this);
                    var $helper = $('<div class="drag-helper">\
                            <i class="twr twr-ban"></i>\
                            <i class="twr twr-check"></i>\
                        </div>');
                    if ($el.hasClass('file')) {
                        var $el_img = $el.find('img');
                        if ($el_img.length <= 0) {
                            var img_url = $el.find('.dir-icon a').css('background-image');
                            img_url = img_url.substr(4, img_url.length - 5);
                            $el_img = $('<img src="' + img_url + '" />');
                        }
                        $el_img.clone().prependTo($helper);
                        return $helper.addClass('file-drag-helper');
                    } else if ($el.hasClass('dir')) {
                        var $el_img = $el.find('img');
                        if ($el_img.length <= 0) {
                            var img_url = $el.find('.dir-icon a').css('background-image');
                            img_url = img_url.substr(4, img_url.length - 5);
                            $el_img = $('<img src="' + img_url + '" />');
                        }
                        $el_img.clone().prependTo($helper);
                        return $helper.addClass('dir-drag-helper');
                    } else {
                        return $el;
                    }
                },
                start: function(e, ui) {
                    var $el = $(this);
                    if ($el.hasClass('loading')) {
                        return false;
                    }

                    $el.addClass('dragging');
                    $listEl.addClass('dragging');
                    $el.on('click.dnd', function(e) {
                        return false;
                    })
                },
                stop: function(e, ui) {
                    var $el = $(this).removeClass('dragging');
                    $listEl.removeClass('dragging');
                    setTimeout(function() {
                        $el.off('click.dnd');
                    }, 100);
                }
            });
        }

        function makeDroppable($dropEl) {
            $dropEl.droppable({
                scope: 'move-file',
                cancel: '.files-view.list-view *',
                activeClass: 'droppable',
                hoverClass: 'dropover',
                tolerance: 'pointer',
                over: function(e, ui) {
                    ui.helper.addClass('dragover');
                },
                out: function(e, ui) {
                    ui.helper.removeClass('dragover');
                },
                drop: function(e, ui) {
                    var $dir = $(this);
                    var $count = $dir.find('.file-count');

                    $count.text($count.text() * 1 + 1);
                    moveFileOrDir(ui.draggable, $dir);
                }
            });
        }

        function moveFileOrDir($srcEl, $targetEl) {
            $srcEl.addClass('loading');
            $targetEl.removeClass('empty');
            $.ajax({
                url: $srcEl.find('.link-move').data('move-url'),
                data: {
                    target_dir_guid: $targetEl.data('guid')
                },
                type: "post"
            }).done(function(result) {
                $srcEl.fadeOut(function() {
                    var $fileListEl = $srcEl.parents('.file-list');
                    var $filesViewEl = $fileListEl.parents('.files-view');
                    $srcEl.remove();
                    if ($fileListEl.children().length <= 0) {
                        $filesViewEl.hide();
                        $filesViewEl.before('<div class="init init-file">\
                                                <div class="title"><span class="twr twr-todo-desc"></span>文件夹已经搬空了</div>\
                                            </div>');
                    }
                });
            });
        }
    },

    refreshSelectedFiles: function() {
        var $selected = $('.files-view .file-or-dir.selected');
        var selectedCount = $selected.length;
        if ( selectedCount > 0) {
            var items = {
                attachments: [],
                uploads: [],
                dirs: []
            };

            $selected.each(function(i, el) {
                $el = $(el);
                if ($el.is('[data-upload-guid]')) {
                    items.uploads.push($el.data('upload-guid'));
                } else if ($el.is('.file')) {
                    items.attachments.push($el.data('guid'));
                } else if ($el.is('.dir')) {
                    items.dirs.push($el.data('guid'));
                }
            });

            $('.selected-info').show()
                .find('.selected-count em')
                .text(selectedCount)
                .end()
                .find('.link-move-file')
                .data('name', selectedCount + '项')
                .data('items', items);

        } else {
            $('.selected-info').hide()
                .find('.selected-count em')
                .text('0')
                .end()
                .find('.link-move-file')
                .removeData('name')
                .removeData('items');
        }
    },

    checkUploadFileSize: function(file) {
        if (file.size && file.size / 1048576 > window.gon.upload_file_size_limit) {
            if (window.gon.upload_file_size_limit === window.gon.max_upload_file_size_limit) {
                window.simple.dialog.message({
                  content: `抱歉，本地文件最大只支持 ${window.gon.upload_file_size_limit}MB。`,
                  width: 400,
                });
            }   else {
                tower.showUploadFileSizeLimitProPopover();
            }
            return false;
        }
        return true;
    }
});

})(jQuery);
